import { TableBody } from "@material-ui/core";
import UserSkeletonRow from "./UserSkeletonRow";

const ROWS = 5;

export default function ListSkeleton() {
  const rows = Array.from(Array(ROWS).keys());

  return (
    <TableBody data-testid="user-list__skeleton">
      {rows.map(row => (
        <UserSkeletonRow key={row} />
      ))}
    </TableBody>
  );
}
